import config from 'config';

import type { Version } from 'core/domains';

export const INITIAL_STATE_APP_VERSION = '0.0';

export const initialState: Version = {
  version: config?.app?.version || INITIAL_STATE_APP_VERSION,
};
